// src/pages/Instagram.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoInstagram,
    IoSparklesOutline, 
    IoCalendarOutline, 
    IoChatbubblesOutline, 
    IoAnalyticsOutline 
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics.png';
import heroBg from '../assets/images/instagram-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "Instagram Management", "item": "https://oolook.in/instagram" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Instagram Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI Instagram Management Tool", "description": "Manage your entire Instagram presence with Oolook. Use AI to generate content for Reels and Stories, schedule posts, reply to DMs, and track your growth.", "url": "https://oolook.in/instagram" };

const pageData = {
  seo: {
    title: "AI Instagram Management Tool | Oolook",
    description: "Grow your Instagram faster. Oolook's AI tools help you create and schedule Reels, Stories, and posts, manage your DMs, and analyze your performance.",
    image: 'https://oolook.in/og/instagram.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoInstagram,
    title: "Master Your Instagram Strategy",
    subtitle: "From viral Reels to engaging Stories, Oolook provides the AI-powered tools you need to create, schedule, manage, and analyze your entire Instagram presence.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "Your Complete Toolkit for Instagram Growth",
    subtitle: "We've built a suite of tools specifically designed to help you succeed on the world's most visual platform.",
    features: [
      { title: "AI Content for Reels & Stories", description: "Generate viral video ideas, scripts, and captions. Create stunning carousels and posts in minutes.", image: image1 },
      { title: "Visual First-Planner & Scheduler", description: "Plan your grid visually with our drag-and-drop calendar. Schedule everything, including Reels and Stories, for auto-publishing.", image: image2 },
      { title: "Manage DMs & Comments", description: "Bring all your Instagram messages and comments into our Unified Inbox to ensure you never miss a conversation.", image: image3 },
      { title: "In-Depth Performance Analytics", description: "Track your follower growth, reach, engagement rates, and find your best-performing content to optimize your strategy.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Results of a Smarter Instagram Strategy",
    benefits: [
      { icon: IoSparklesOutline, title: "Create Better Content", description: "Use AI to create more engaging content that captures attention and stops the scroll." },
      { icon: IoCalendarOutline, title: "Post Consistently", description: "Maintain an active, engaging presence with effortless content scheduling and automation." },
      { icon: IoChatbubblesOutline, title: "Engage Your Community", description: "Build a loyal following by responding to comments and DMs quickly and personally." },
      { icon: IoAnalyticsOutline, title: "Grow Faster", description: "Use data-driven insights to understand what works and accelerate your follower growth." }
    ]
  },
  stepByStep: {
    title: "Go from Zero to Instagram Pro",
    subtitle: "Our intuitive workflow makes powerful Instagram management accessible to everyone.",
    steps: [
      { title: "1. Connect Your Instagram Account", description: "Securely link your Instagram Business or Creator account to unlock all of Oolook's features." },
      { title: "2. Generate Your First Post with AI", description: "Tell our AI about your topic. It will generate captions, hashtags, and even visual ideas for your next post or Reel." },
      { title: "3. Plan Your Grid", description: "Drag your newly created content onto the visual planner to see how it will look on your profile before it goes live." },
      { title: "4. Schedule & Analyze", description: "Schedule your posts for the optimal times and watch as Oolook tracks every like, comment, and share." }
    ]
  },
  targetAudience: {
    title: "The Ultimate Tool for Instagram-First Brands"
  }
};

const Instagram = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default Instagram;